import React, { useEffect } from 'react'; // Import useEffect
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole }) => {
  const location = useLocation();
  const { isAuthenticated, user, isLoading: authLoading } = useAuth(); // Renamed `loading` to `authLoading` for clarity and consistency

  // Add console logs to trace the state
  useEffect(() => {
  }, [authLoading, isAuthenticated, user]);

  if (authLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>Betöltés...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    // A belépés után ide térünk vissza (pl. levélben kapott link)
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  // MÓDOSÍTVA: Jogosultság ellenőrzés
  if (requiredRole) {
    const userRole = user?.userType;
    // Biztosítjuk, hogy a requiredRole mindig tömb legyen, még ha csak egy string is jön be
    const rolesArray = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

    if (!userRole || !rolesArray.includes(userRole)) {
      console.warn(`Access denied: User ${user?.email} (role: ${userRole}) tried to access a ${rolesArray.join(',')} route.`);
      return <Navigate to="/dashboard" replace />; // Vagy egy /unauthorized oldalra
    }
  }

  return children;
};

export default ProtectedRoute;